// ---------------- Hook to call the api endpoint for the models --------------------
// ----------------------------------------------------------------------------------
import { useState, useEffect } from 'react';
import { getAvailableModels } from '../services/api';

// hook to fetch available models and their default top_n values
export const useAvailableModels = () => {

  // create state variables
  const [models, setModels] = useState([]);
  const [defaultTopN, setDefaultTopN] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

    let cancelled = false;

    setLoading(true); // set loading to true when the request starts
    setError(null); // reset error state before making the request

    getAvailableModels() // call the API to get available models
      .then((data) => { // once the data is returned set the models and the default top_n values
        if (cancelled) return;
        setModels(data.models || []);
        setDefaultTopN(data.default_top_n || {});
      })
      .catch((err) => { // catch all errors
        if (cancelled) return;
        console.error('Error fetching available models:', err);
        setError(err.message || 'Failed to fetch model defaults');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; }; // return nothing if comp is unmounted
  }, []);

  return { models, defaultTopN, loading, error };
};
